import GenericDAO from './../generic-dao'

const findAll = (params) => GenericDAO.find(`/webcli/historico-integracao/`, params, {ignorarEstabelecimento:true})
const find = (id) => GenericDAO.find(`/webcli/historico-integracao/${ id }/`)
const getStatusCode = (params) => GenericDAO.find('/webcli/historico-integracao/status-code/', params, {ignorarEstabelecimento: true})
export default {
    find,
    findAll,
    getStatusCode
}